var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    typography = _ref.typography;
  return {
    quizSavingColor: colors.lightGray,
    quizSavingMargin: spacing.large,
    buttonsHolderMargin: spacing.xLarge,
    menuIconMargin: spacing.xSmall,
    menuIconFontSize: typography.fontSizeLarge
  };
};
export default generateComponentTheme;